<template>
  <div class="blog-inner">
    <div class="media">
      <div class="image">
        <img :src="$backendPublic + article.image" :alt="article.title" />
      </div>
    </div>
    <div class="content">
      <ul class="meta">
        <!-- <li>
          نویسنده:
          <a :href="blogDetailsData.metas.authorLink">{{
            blogDetailsData.metas.author
          }}</a>
        </li> -->
        <li>
          {{ article.date }}
        </li>
        <!-- <li>
                    <a href="commentLink">{{ blogDetailsData.metas.comment }}</a>
                </li> -->
      </ul>
      <h2 class="title">{{ article.title }}</h2>
      <div class="desc section-space--bottom--30">
        <p v-html="article.content"></p>

        <!-- <p>{{ blogDetailsData.desc_para1 }}</p> -->
        <!-- <p>{{ blogDetailsData.desc_para2 }}</p> -->

        <!-- <blockquote
          class="blockquote section-space--bottom--30 section-space--top--30"
        >
          <p>{{ blogDetailsData.blockQuote }}</p>
          <span class="author">__{{ blogDetailsData.author }}</span>
        </blockquote> -->

        <!-- <p>{{ blogDetailsData.desc_para3 }}</p>
        <p>{{ blogDetailsData.desc_para4 }}</p> -->
      </div>
      <!-- <ul class="tags">
        <li v-for="tag in blogDetailsData.tags" :key="tag.id">
          <router-link :to="tag.link">{{ tag.tagName }}</router-link>
        </li>
      </ul> -->
    </div>
  </div>
</template>

<script>
import { NewsService } from "@/store/services/news.service.js"

export default {
  props: ["blogDetailsData"],
  data() {
    return {
      article: {},
    }
  },
  mounted() {
    NewsService.show(this.$route.params.slug).then(({ data }) => {
      this.article = data.data
    })
  },
}
</script>
